import { CreateTicket as CreateTicketComponent } from 'features/CreateTicket';

const CreateTicket = (): JSX.Element => {
	return <CreateTicketComponent />;
};
export default CreateTicket;
